import { normalizeLower } from './serviceNormalization';

const isWithinDateRange = (dateValue, dateRange) => {
  if (!dateRange?.start && !dateRange?.end) return true;
  if (!dateValue) return false;
  const value = new Date(dateValue);
  if (Number.isNaN(value.getTime())) return false;

  if (dateRange.start) {
    const start = new Date(dateRange.start);
    if (value < start) return false;
  }
  if (dateRange.end) {
    const end = new Date(dateRange.end);
    if (value > end) return false;
  }
  return true;
};

export const filterServiceJobs = (jobs = [], filters = {}) => {
  const vendor = normalizeLower(filters.vendor);
  const tag = normalizeLower(filters.tag);
  const status = normalizeLower(filters.status);
  const onlyInvoiceVisible = Boolean(filters.invoiceVisibleOnly);
  const hasVendor = filters.hasVendor;
  const dateRange = filters.dateRange;

  return jobs.filter((job) => {
    if (!isWithinDateRange(job.billDate, dateRange)) return false;
    if (vendor) {
      const vendorMatch = normalizeLower(job.vendorId) === vendor || normalizeLower(job.vendorName) === vendor;
      if (!vendorMatch) return false;
    }
    if (tag && normalizeLower(job.serviceName) !== tag) return false;
    if (status && normalizeLower(job.status) !== status) return false;
    if (onlyInvoiceVisible && !job.showOnInvoice) return false;
    if (hasVendor === true && !normalizeLower(job.vendorId) && !normalizeLower(job.vendorName)) return false;
    if (hasVendor === false && (normalizeLower(job.vendorId) || normalizeLower(job.vendorName))) return false;
    return true;
  });
};
